import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "../Components/Layout";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import DailyReport from "../Components/timesheet/DailyReport";
import WeeklyReport from "../Components/timesheet/WeeklyReport";


const AttendanceScreen = () => {
  const [filter, setFilter] = useState("daily"); // State for switching between daily and weekly reports
  const [date, setDate] = useState("");

  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDate(today);
    setDate(formattedDate);
  }, []);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`; // YYYY-MM-DD format
  };

  return (
    <Layout>
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Employee Management</h2>
          <div className="d-flex">
            <button
              className="btn btn-outline-secondary me-2"
              onClick={() => setFilter("daily")}
            >
              Daily Report
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => setFilter("weekly")}
            >
              Weekly Report
            </button>
          </div>
        </div>

        {/* Conditionally Render Components */}
        {filter === "daily" ? (
          <DailyReport date={date} />
        ) : (
          <WeeklyReport />
        )}
      </div>
    </Layout>
  );
};

export default AttendanceScreen;
